import React, { FunctionComponent, useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { formatDate, formatNumberColor, formatStringColor } from '../helpers/utils';
import IndicatorsModel from '../models/indicatorsModel';
import IndicatorsService from '../services/indicatorsService';
import { Breadcrumb, Col, Container, Row, Spinner, Stack, Table } from 'react-bootstrap';
import IndicatorsHistoryModel from '../models/indicatorsHistory';
  
  
const IndicatorsDetailPage: FunctionComponent = () => {
  const { uid } = useParams<{ uid: string }>();

  const history = useHistory();

  const [indicators, setIndicators] = useState<IndicatorsModel>();
  const [indicatorsHistory, setIndicatorsHistory] = useState<IndicatorsHistoryModel[]>();
  const [isLoading, setIsLoading] = useState(true); 

  useEffect(() => {
    IndicatorsService.getIndicator(Number(uid))
      .then(indicators => {
        checkImage(indicators!)
        setIndicators(indicators!);
      })
      
    IndicatorsService.getIndicatorHistory(Number(uid))
      .then(tabIndicators => {
        if (tabIndicators && Array.isArray(tabIndicators)) {
          tabIndicators = tabIndicators.slice().reverse();
          setIndicatorsHistory(tabIndicators);
        } 
      })
      .finally( () => {setIsLoading(false);})
  }, []);

  // Fonction pour vérifier si l'image chargée est valide
  const checkImage = (indicators: IndicatorsModel) => {
    const img = new Image();
    img.src = indicators.url + "/favicon.ico";
    img.onload = () => {
      indicators.imgIsValid = true;
    };
    img.onerror = () => {
      indicators.imgIsValid = false;
    };
  };

  return (
    <Container fluid className="py-4 px-3">
      <Breadcrumb>
        <Breadcrumb.Item href="/" className='breadcrumb-link'>Accueil</Breadcrumb.Item>
        <Breadcrumb.Item active className='breadcrumb-text'>{indicators?.name}</Breadcrumb.Item>
      </Breadcrumb>
      <h1 style={{ paddingBottom: '20px', borderBottom: '1px solid lightgray'}}><img src={indicators?.url+"/favicon.ico"} alt={indicators?.host} width="30" height="30" style={{marginRight:'15px'}}/>{indicators?.name}</h1>
      {isLoading? <Spinner animation="border" />:
        <Row>
          <Col sm={9}>
            <h3 style={{ marginTop: '20px'}}>Historique des mesures</h3>
            <p><small>L'historique concerne les 30 derniers jours.</small></p>
            <Table responsive striped hover>
              <thead>
                <tr>
                  <th>Date</th>
                  <th>HTTP</th>
                  <th>SSL</th>
                  <th>Ports</th>
                  <th>Cookies</th>
                  <th>Performance</th>
                  <th>Accessibilité</th>
                  <th>EcoIndex</th>
                </tr>
              </thead>
              <tbody>
                {indicatorsHistory?indicatorsHistory.map((indicators, index) => (
                <tr key={index}>
                  {/* <th align="right" scope="row"><b>{indicators.name}</b></th> */}
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.date?formatDate(indicators.date):'-'}</td>  
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.httpScore?formatStringColor(indicators.httpScore):'-'}</td>
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.sslScore?formatStringColor(indicators.sslScore):'-'}</td>
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.nbOpenPorts?indicators.nbOpenPorts:'-'}</td>
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.nbCookies?indicators.nbCookies:'-'}</td>
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.performanceScore?formatNumberColor(Math.round(indicators.performanceScore)):'-'}</td>
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.accessibilityScore?formatNumberColor(indicators.accessibilityScore):'-'}</td> 
                  <td align="left" style={{ borderLeft: "1px solid white" }}>{indicators.ecoIndexScore?formatStringColor(indicators.ecoIndexScore):'-'}</td>
                </tr>
                )):<tr key="0"><td align="center" colSpan={8}>Aucune donnée</td></tr>}
              </tbody>
            </Table>
          </Col>
          <Col sm={3}>
            <h3 style={{ marginTop: '20px'}}>Détection des pages</h3>
            <p><small>La présence de ces pages est obligatoire.</small></p>
            <Stack gap={3}>
              <div className="p-2" style={{ borderBottom:'1px solid lightgray'}}>
                {indicators?.isMentionsLegales?
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2"><a target='_blank' rel='noreferrer' href={indicators?.url+"/mentions-legales"}>Mentions légales</a></div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-check-round-full" /></div>
                  </Stack>:
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2">Mentions légales</div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-close-round-full"/></div>
                  </Stack>
                }
                <p style={{marginTop:'20px'}}>Cette page présente les personnes en charge de la plateforme.</p>
              </div>
              <div className="p-2" style={{ borderBottom:'1px solid lightgray'}}>
                {indicators?.isPolitiqueConfidentialite?
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2"><a target='_blank' rel='noreferrer' href={indicators?.url+"/donnees-personnelles"}>Politique de confidentialité</a></div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-check-round-full"/></div>
                  </Stack>:
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2">Politique de confidentialité</div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-close-round-full"/></div>
                  </Stack>
                }
                <p style={{marginTop:'20px'}}>Cette page informe les utilisateurs sur le traitement des données personnelles.</p>
              </div>
              <div className="p-2" style={{ borderBottom:'1px solid lightgray'}}>
                {indicators?.isPageStats?
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2"><a target='_blank' rel='noreferrer' href={indicators?.url+"/stats"}>Statistiques</a></div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-check-round-full"/></div>
                  </Stack>:
                  <Stack direction="horizontal" gap={3}>
                    <div className="p-2">Statistiques</div>
                    <div className="p-2 ms-auto"><span aria-hidden="true" className="icon icon-close-round-full"/></div>
                  </Stack>
                }
                <p style={{marginTop:'20px'}}>Cette page regroupe différentes données de pilotage du produit.</p>
              </div>
            </Stack>
          </Col>
        </Row>
      }
    </Container>
  );
}
  
export default IndicatorsDetailPage;